module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTJXIbJPHapXHapTLaZPJapXCapPJbJPIbJXJbJfHZpTIbJPHapPJbJXJapTHa5XHapXJbJhV5FkAAAARdFJOUwDancMcUAz1/m4alUS3t+PReeMu9gAAAMlJREFUKM9tUosOwyAIRGsH2JmO///ZIeCj2TBp4pXzzkMAr8ItIabGBfaqmYSicl34iSIkXiR4DpzJYLLVPxz95J2ryDgVA6a1sOtk+WEIZfU54eh2oTKUBwPPV+obhiY7A9/wujujQTLGdRmj44d1JkAD9DLRf4QvQGf0P4YPLUiuoP44zjFGghaelGP9zlBxHlbz0CWPq9Cw+rkjRrELaiRjM4OnLgkFPesVvHqqK/YH49wGtY+K99FOBq3Rqk6e3h6P4d/z+QKuJBbGccbwXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-cancel.png
// module id = ZS61
// module chunks = 34